import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import { PDFViewer } from 'pdfjs-dist/web/pdf_viewer.js';
import pdfjsLib from 'pdfjs-dist/webpack';
import 'pdfjs-dist/web/pdf_viewer.css';

function Viewer(_ref) {
  var initialScale = _ref.initialScale,
      onError = _ref.onError,
      url = _ref.url;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      doc = _React$useState2[0],
      setDoc = _React$useState2[1];

  var viewerRef = React.useRef();
  var pdfViewer = React.useRef();
  var loadPdf = React.useCallback(function (url) {
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function (doc) {
      return setDoc(doc);
    }, function (err) {
      return onError();
    });
    pdfViewer.current = new PDFViewer({
      container: viewerRef.current
    });
  }, [onError]);
  React.useEffect(function () {
    loadPdf(url);
  }, [url, loadPdf]);
  React.useEffect(function () {
    if (pdfViewer && pdfViewer.current) {
      pdfViewer.current.setDocument(doc);
      pdfViewer.current.currentScale = initialScale;
    }
  }, [doc, initialScale]);
  return React.createElement("div", {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    ref: viewerRef,
    className: "note-editor-pdf-viewer",
    spellCheck: false
  }, React.createElement("div", {
    className: "pdfViewer"
  }));
}

Viewer.propTypes = {
  initialScale: PropTypes.number,
  onError: PropTypes.func,
  url: PropTypes.string
};
export default React.memo(Viewer);